import React from "react";

const ArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      {...props}
    >
      <path
        d="M2 0.5C0.763932 0.5 0.0583591 1.91115 0.8 2.9L4.8 8.23333C5.4 9.03333 6.6 9.03333 7.2 8.23333L11.2 2.9C11.9416 1.91115 11.2361 0.5 10 0.5H2Z"
        fill="#000000"
        stroke="white"
      />
    </svg>
  );
};

export default ArrowIcon;
